// BBX — Cart Modal Rexy (versión estable final)
// - Modal abre/cierra
// - Cada card = 1 línea real del carrito (Shopify)
// - S/M/L CAMBIA la talla SOLO de su card (no suma cantidad)
// - "Agregar +1" crea otra línea con la talla actual de esa card
// - Nuevo ítem (add-to-cart o Agregar +1) va SIEMPRE hasta arriba
// - CartLock evita que spamear la X borre todo de golpe
// - Resumen + mensajes de urgencia / envío gratis / outfit

(function () {
  var modal = document.getElementById('bbx-cart-modal');
  if (!modal) return;

  var itemsContainer = modal.querySelector('[data-bbx-cart-items]');
  var emptyState     = modal.querySelector('[data-bbx-cart-empty]');
  var totalEl        = modal.querySelector('[data-bbx-cart-total]');
  var checkoutBtn    = modal.querySelector('[data-bbx-cart-checkout]');
  var reviewEl       = modal.querySelector('[data-bbx-cart-summary]');
  var continueBtn    = modal.querySelector('[data-bbx-cart-continue]');

  // Incentivos
  var urgencyEl = modal.querySelector('[data-bbx-cart-urgency]');
  var freeEl    = modal.querySelector('[data-bbx-cart-free]');
  var outfitEl  = modal.querySelector('[data-bbx-cart-outfit]');

  var currentCart  = null;
  var productCache = {};
  var cardOrder    = []; // orden visual por uid
  var cartLock     = false; // evita operaciones simultáneas

  // ==========================
  // Helpers
  // ==========================
  function makeUid() {
    return 'bbx-' + Date.now() + '-' + Math.floor(Math.random() * 1000000);
  }

  function getHandleFromUrl(url) {
    if (!url) return '';
    var clean = url.split('?')[0];
    var parts = clean.split('/');
    return parts[parts.length - 1];
  }

  function getUidFromItem(item, fallbackIndex) {
    if (item.properties && item.properties._bbx_uid) {
      return item.properties._bbx_uid;
    }
    return 'line-' + fallbackIndex;
  }

  function getProduct(handle) {
    if (!handle) return Promise.reject('No handle');
    if (productCache[handle]) return Promise.resolve(productCache[handle]);

    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        productCache[handle] = prod;
        return prod;
      });
  }
var BBX_CART_COUNT = null;

function bbxSetCount(n){
  BBX_CART_COUNT = Math.max(0, Number(n||0));
  document.querySelectorAll('[data-bbx-cart-count], [data-cart-count], .cart-count, .header__cart-count')
    .forEach(function(el){ el.textContent = String(BBX_CART_COUNT); });
}

function bbxBumpCount(delta){
  if (BBX_CART_COUNT == null) BBX_CART_COUNT = 0;
  bbxSetCount(BBX_CART_COUNT + delta);
}

  // Match exacto S/M/L
  function findVariantBySize(product, size) {
    if (!product || !product.variants) return null;
    var target = size.toUpperCase();

    return product.variants.find(function (v) {
      var raw = (v.option1 || v.title || '').toUpperCase().trim();
      var opt = raw.split('/')[0].trim();
      return opt === target;
    });
  }

  function ensureUid(props) {
    if (!props) props = {};
    if (!props._bbx_uid) {
      props._bbx_uid = makeUid();
    }
    return props;
  }

  function releaseLock() {
    cartLock = false;
  }

  // ==========================
  // Abrir / cerrar modal
  // ==========================
  function openModal(e) {
    if (e) e.preventDefault();
    modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    loadCart();
    document.documentElement.classList.add('bbx-cart-open');
    bbxUrgencyStartLoop();
  }

  function closeModal() {
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
    document.documentElement.classList.remove('bbx-cart-open');

    bbxUrgencyStopLoop();
bbxUrgencyHide();
  }

  // Iconos de carrito
  var openers = document.querySelectorAll('[data-bbx-cart-open]');
  openers.forEach(function (btn) {
    btn.addEventListener('click', openModal);
  });

  modal.querySelectorAll('[data-bbx-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', function (e) {
    if (e.target.classList.contains('bbx-cart-backdrop')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // ==========================
  // Interceptar add-to-cart
  // ==========================
  function interceptAddToCart() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.__bbxCartIntercept) continue;
      form.__bbxCartIntercept = true;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var fd = new FormData(this);
        if (!fd.has('properties[_bbx_uid]')) {
          fd.append('properties[_bbx_uid]', makeUid());
        }
        bbxBumpCount(1);

        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            openModal();
          })
          .catch(function (err) {
            console.error('Add-to-cart error', err);
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptAddToCart);
  } else {
    interceptAddToCart();
  }

  // ==========================
  // Ajax cart base
  // ==========================
 function loadCart(onDone) {
  fetch('/cart.js?ts=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      currentCart = cart;
      renderCart(cart);
      if (typeof onDone === 'function') onDone();
    })
    .catch(function (err) {
      console.error('Cart error', err);
      if (typeof onDone === 'function') onDone();
    });
}

  function bbxUpdateHeaderCount(count){
  count = Number(count || 0);

  // Ajusta estos selectores si tu badge usa otro
  var nodes = document.querySelectorAll(
    '[data-bbx-cart-count], [data-cart-count], .cart-count, .header__cart-count'
  );

  nodes.forEach(function(el){
    el.textContent = String(count);
    el.style.display = count > 0 ? '' : '';
    el.classList.toggle('is-empty', count <= 0);
  });
}

// resta la qty de esa línea (si la tenemos)
var q = 1;
try {
  var it = currentCart && currentCart.items && currentCart.items.find(function(x){ return x.key === key; });
  if (it && it.quantity) q = it.quantity;
} catch(e){}
bbxBumpCount(-q);

  function removeLineByKey(key) {
    if (!key) return;
    if (cartLock) return;
    cartLock = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        currentCart = cart;
        renderCart(cart);
        releaseLock();
      })
      .catch(function (err) {
        console.error('Remove error', err);
        releaseLock();
      });
  }

  function changeVariantByKey(key, newVariantId) {
    if (!currentCart || !currentCart.items) return;
    if (!key || !newVariantId) return;
    if (cartLock) return;
    cartLock = true;

    var item = null;
    for (var i = 0; i < currentCart.items.length; i++) {
      if (currentCart.items[i].key === key) {
        item = currentCart.items[i];
        break;
      }
    }
    if (!item) { releaseLock(); return; }

    if (String(item.variant_id) === String(newVariantId)) {
      releaseLock();
      return;
    }

    var qty   = item.quantity;
    var props = ensureUid(item.properties);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: newVariantId,
            quantity: qty,
            properties: props
          })
        });
      })
      .then(function () {
        loadCart(function () { releaseLock(); });
      })
      .catch(function (err) {
        console.error('Variant change error', err);
        releaseLock();
      });
  }

  function addOne(variantId) {
    if (!variantId) return;
    if (cartLock) return;
    cartLock = true;

    var props = { _bbx_uid: makeUid() };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: props
      })
    })
      .then(function () {
        loadCart(function () { releaseLock(); });
      })
      .catch(function (err) {
        console.error('Add one error', err);
        releaseLock();
      });
  }

  // ==========================
// BBX — URGENCY HOOKS ENGINE
// (pausar/continuar/forzar/cambiar copy)
// ==========================
var BBX_URGENCY = {
  enabled: true,
  paused: false,
  mode: 'auto',            // 'auto' | 'manual'
  manualText: '',
  pulseMs: 2400,           // cada cuánto intenta "pulso"
  showMs: 1800,            // cuánto dura visible cada pulso
  timer: null
};

function bbxUrgencyShow(text){
  if(!urgencyEl) return;
  urgencyEl.textContent = text || '';
  urgencyEl.style.display = (text ? 'block' : 'none');
  urgencyEl.classList.add('is-show');
}

function bbxUrgencyHide(){
  if(!urgencyEl) return;
  urgencyEl.classList.remove('is-show');
  urgencyEl.style.display = 'none';
}

function bbxUrgencyPulse(text){
  if(!urgencyEl) return;
  // micro anim si quieres (CSS optional)
  bbxUrgencyShow(text);
  clearTimeout(BBX_URGENCY._hideTO);
  BBX_URGENCY._hideTO = setTimeout(function(){
    bbxUrgencyHide();
  }, BBX_URGENCY.showMs);
}

function bbxUrgencyStopLoop(){
  if(BBX_URGENCY.timer){
    clearInterval(BBX_URGENCY.timer);
    BBX_URGENCY.timer = null;
  }
}

function bbxUrgencyStartLoop(){
  bbxUrgencyStopLoop();
  BBX_URGENCY.timer = setInterval(function(){
    if(!BBX_URGENCY.enabled) return;
    if(BBX_URGENCY.paused) return;
    if(!modal.classList.contains('is-active')) return;

    // En modo manual, NO autogeneramos. Solo pulso si hay texto.
    if(BBX_URGENCY.mode === 'manual'){
      if(BBX_URGENCY.manualText){
        bbxUrgencyPulse(BBX_URGENCY.manualText);
      }
      return;
    }

    // modo auto: disparamos evento para que TU lógica decida el texto
    window.dispatchEvent(new CustomEvent('bbx:cart:urgency:tick', {
      detail: { cart: currentCart || null }
    }));
  }, BBX_URGENCY.pulseMs);
}

// API global (para dispararlo desde cualquier script)
window.BBX_CART = window.BBX_CART || {};
window.BBX_CART.urgency = {
  pause: function(){ BBX_URGENCY.paused = true; bbxUrgencyHide(); },
  resume: function(){ BBX_URGENCY.paused = false; },
  enable: function(){ BBX_URGENCY.enabled = true; },
  disable: function(){ BBX_URGENCY.enabled = false; bbxUrgencyHide(); },
  setMode: function(mode){ BBX_URGENCY.mode = (mode === 'manual' ? 'manual' : 'auto'); },
  setText: function(text){ BBX_URGENCY.manualText = String(text || ''); },
  pulse: function(text){ bbxUrgencyPulse(String(text || BBX_URGENCY.manualText || '')); },
  setTiming: function(pulseMs, showMs){
    if(Number(pulseMs)) BBX_URGENCY.pulseMs = Number(pulseMs);
    if(Number(showMs))  BBX_URGENCY.showMs  = Number(showMs);
    bbxUrgencyStartLoop();
  }
};

// Events para control externo (hooks reales)
window.addEventListener('bbx:cart:urgency:pause', function(){ window.BBX_CART.urgency.pause(); });
window.addEventListener('bbx:cart:urgency:resume', function(){ window.BBX_CART.urgency.resume(); });
window.addEventListener('bbx:cart:urgency:disable', function(){ window.BBX_CART.urgency.disable(); });
window.addEventListener('bbx:cart:urgency:enable', function(){ window.BBX_CART.urgency.enable(); });
window.addEventListener('bbx:cart:urgency:manual', function(e){
  window.BBX_CART.urgency.setMode('manual');
  window.BBX_CART.urgency.setText(e && e.detail && e.detail.text ? e.detail.text : '');
});
window.addEventListener('bbx:cart:urgency:auto', function(){
  window.BBX_CART.urgency.setMode('auto');
});
window.addEventListener('bbx:cart:urgency:pulse', function(e){
  var t = e && e.detail && e.detail.text ? e.detail.text : '';
  window.BBX_CART.urgency.pulse(t);
});
  // ==========================
  // Resumen + incentivos
  // ==========================
  function updateSummaryAndIncentives(cart) {
    var count = cart.item_count || 0;
    var total = (cart.total_price || 0) / 100;

    // Resumen simple
    if (reviewEl) {
      if (!count) {
        reviewEl.textContent = 'Tu carrito está vacío.';
      } else {
        reviewEl.textContent = 'Tienes ' + count + ' piezas en tu carrito.';
      }
    }

    // Urgencia
    if (urgencyEl) {
      if (count >= 4) {
        urgencyEl.textContent = ' Este combo se va a agotar rápido.';
        urgencyEl.style.display = 'block';
      } else {
        urgencyEl.textContent = '';
        urgencyEl.style.display = 'none';
      }
    }

    // Envío gratis (umbral configurable)
    var FREE_THRESHOLD = 3000; // MXN
    if (freeEl) {
      if (!count) {
        freeEl.textContent = '';
        freeEl.style.display = 'none';
      } else {
        if (total >= FREE_THRESHOLD) {
          freeEl.textContent = '¡Tienes envío gratis!';
        } else {
          var falta = FREE_THRESHOLD - total;
          if (falta < 0) falta = 0;
          freeEl.textContent = 'Agrega $' + falta.toFixed(0) + ' para envío gratis.';
        }
        freeEl.style.display = 'block';
      }
    }

    // Outfit
    if (outfitEl) {
      if (count >= 3) {
        outfitEl.textContent = 'Outfit completo listo para salir 💥';
        outfitEl.style.display = 'block';
      } else {
        outfitEl.textContent = '';
        outfitEl.style.display = 'none';
      }
    }
  }

  // ==========================
  // Render de carrito
  // ==========================
  function renderCart(cart) {
    itemsContainer.innerHTML = '';
bbxUpdateHeaderCount(cart.item_count || 0);

updateShippingSavings(cart);
updateShippingSavings(cart);
bbxEnsureWAPromo(cart);

    // Carrito vacío
    if (!cart.items || !cart.items.length) {
      if (emptyState) {
        emptyState.style.display = 'block';
        itemsContainer.appendChild(emptyState);
      }
      if (totalEl) totalEl.textContent = '$0.00';
      updateSummaryAndIncentives({ item_count: 0, total_price: 0 });

      if (continueBtn) {
        continueBtn.onclick = function () {
          window.location.href = '/collections/all';
        };
      }
      if (checkoutBtn) {
        checkoutBtn.textContent = 'Ir a comprar';
        checkoutBtn.onclick = function () {
          window.location.href = '/collections/all';
        };
      }
      return;
    }
    

    if (emptyState) emptyState.style.display = 'none';

    // Construir lista con uid
    var keyedItems = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var uid  = getUidFromItem(item, i);
      keyedItems.push({ item: item, uid: uid });
    }

    // Inicializar / actualizar orden estable
    if (cardOrder.length === 0) {
      keyedItems.forEach(function (entry) {
        cardOrder.push(entry.uid);
      });
    } else {
      keyedItems.forEach(function (entry) {
        if (cardOrder.indexOf(entry.uid) === -1) {
          // nuevo UID → al principio
          cardOrder.unshift(entry.uid);
        }
      });
    }

    keyedItems.sort(function (a, b) {
      var ia = cardOrder.indexOf(a.uid);
      var ib = cardOrder.indexOf(b.uid);
      if (ia === -1) ia = 9999;
      if (ib === -1) ib = 9999;
      return ia - ib;
    });

    // Render cards
    for (var j = 0; j < keyedItems.length; j++) {
      var entry  = keyedItems[j];
      var it     = entry.item;
      var handle = getHandleFromUrl(it.url);
      var key    = it.key;
      var line   = j + 1;

      var div = document.createElement('div');
      div.className = 'bbx-cart-item';
      div.setAttribute('data-bbx-cart-key', key);

      div.innerHTML = ''
        + '<a href="' + it.url + '" class="bbx-cart-item-thumb">'
        +   '<img src="' + it.image + '" alt="' + (it.title || '') + '">'
        + '</a>'
        + '<div class="bbx-cart-item-info">'
        +   '<a href="' + it.url + '" class="bbx-cart-item-title">'
        +     it.product_title
        +   '</a>'
        +   '<div class="bbx-cart-item-meta">'
        +     '<span class="bbx-cart-item-variant">'
        +       (it.variant_title || '')
        +     '</span>'
        +   '</div>'
        +   '<div class="bbx-cart-item-actions"'
        +        ' data-bbx-cart-line="' + line + '"'
        +        ' data-bbx-cart-key="' + key + '">'
        +     '<button type="button"'
        +             ' class="bbx-cart-addone"'
        +             ' data-bbx-cart-addone'
        +             ' data-bbx-cart-line="' + line + '"'
        +             ' data-bbx-cart-key="' + key + '"'
        +             ' data-bbx-cart-variant-id="' + it.variant_id + '">'
        +       'Agregar +1'
        +     '</button>'
        +     '<div class="bbx-cart-sizes"'
        +          ' data-bbx-cart-sizes'
        +          ' data-bbx-cart-line="' + line + '"'
        +          ' data-bbx-cart-key="' + key + '"'
        +          ' data-bbx-cart-handle="' + handle + '"'
        +          ' data-bbx-cart-current-id="' + it.variant_id + '">'
        +     '</div>'
        +     '<div class="bbx-cart-item-qty">x' + it.quantity + '</div>'
        +   '</div>'
        + '</div>'
        + '<button class="bbx-cart-item-remove"'
+         ' type="button"'
+         ' data-bbx-cart-remove'
+         ' data-bbx-cart-line="' + line + '"'
+         ' data-bbx-cart-key="' + key + '"'
+         ' aria-label="Eliminar">'
+   '<img'
+     ' src="https://cdn.shopify.com/s/files/1/0635/5324/1174/files/icons8-basura.svg?v=1768076886"'
+     ' alt=""'
+     ' class="bbx-cart-remove-icon"'
+     ' loading="lazy"'
+     ' decoding="async"'
+   '>'
+ '</button>';


      itemsContainer.appendChild(div);
      bbxSetCount(cart.item_count || 0);

      buildSizeButtons(line, handle, it.variant_id, key);
    }

    // Total
    if (totalEl) {
      var total = cart.total_price / 100;
      totalEl.textContent = '$' + total.toFixed(2);
    }

    // Resumen + incentivos
    updateSummaryAndIncentives(cart);

    // Seguir comprando → por tag del primer producto
    if (continueBtn) {
      continueBtn.setAttribute('data-bbx-target', '/collections/all');
      continueBtn.onclick = function () {
        var target = continueBtn.getAttribute('data-bbx-target') || '/collections/all';
        window.location.href = target;
      };

      try {
        var firstItem = cart.items[0];
        var handleFirst = getHandleFromUrl(firstItem.url);
        getProduct(handleFirst).then(function (product) {
          if (product && product.tags && product.tags.length) {
            var tag = product.tags[0];
            var slug = encodeURIComponent(tag.toLowerCase().replace(/\s+/g, '-'));
            continueBtn.setAttribute('data-bbx-target', '/collections/all/' + slug);
          }
        });
      } catch (e) {
        // se queda /collections/all
      }
    }

    // Checkout
    if (checkoutBtn) {
      checkoutBtn.textContent = 'COMPRAR AHORA';
      checkoutBtn.onclick = function () {
        window.location.href = '/checkout';
      };
    }
  }

  // ==========================
  // Construir botones S/M/L
  // ==========================
  function buildSizeButtons(line, handle, currentVariantId, key) {
    var selector = '[data-bbx-cart-sizes][data-bbx-cart-line="' + line + '"][data-bbx-cart-key="' + key + '"]';
    var container = modal.querySelector(selector);
    if (!container) return;

    getProduct(handle).then(function (product) {
      container.innerHTML = '';

      var sizes = ['S', 'M', 'L'];
      var activeVariantId = null;

      for (var i = 0; i < sizes.length; i++) {
        var size = sizes[i];
        var variant = findVariantBySize(product, size);
        if (!variant) continue;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = size;
        btn.className = 'bbx-cart-size-btn';
        btn.setAttribute('data-bbx-cart-size-btn', '');
        btn.setAttribute('data-bbx-cart-line', line);
        btn.setAttribute('data-bbx-cart-key', key);
        btn.setAttribute('data-bbx-cart-variant-id', variant.id);

        if (String(variant.id) === String(currentVariantId)) {
          btn.classList.add('is-active');
          activeVariantId = variant.id;
        }

        container.appendChild(btn);
      }

      if (!container.children.length) {
        container.style.display = 'none';
        return;
      }

      if (!activeVariantId) {
        var first = container.querySelector('.bbx-cart-size-btn');
        if (first) {
          first.classList.add('is-active');
          activeVariantId = first.getAttribute('data-bbx-cart-variant-id');
        }
      }

      var addBtnSelector =
        '[data-bbx-cart-addone][data-bbx-cart-line="' + line + '"][data-bbx-cart-key="' + key + '"]';
      var addBtn = modal.querySelector(addBtnSelector);
      if (addBtn && activeVariantId) {
        addBtn.setAttribute('data-bbx-cart-variant-id', activeVariantId);
      }
    }).catch(function () {
      container.style.display = 'none';
    });
  }

  // ==========================
  // Delegación de eventos dentro del modal
  // ==========================
  modal.addEventListener('click', function (e) {
    // Borrar línea
    var removeBtn = e.target.closest('[data-bbx-cart-remove]');
    if (removeBtn) {
      var key = removeBtn.getAttribute('data-bbx-cart-key');
      if (key) removeLineByKey(key);
      return;
    }

    // Agregar +1
    var addBtn = e.target.closest('[data-bbx-cart-addone]');
    if (addBtn) {
      var variant = addBtn.getAttribute('data-bbx-cart-variant-id');
      if (!variant) {
        var keyA = addBtn.getAttribute('data-bbx-cart-key');
        if (keyA && currentCart && currentCart.items) {
          for (var i = 0; i < currentCart.items.length; i++) {
            if (currentCart.items[i].key === keyA) {
              variant = currentCart.items[i].variant_id;
              break;
            }
          }
        }
      }
      if (variant) addOne(variant);
      return;
    }

    // Cambiar talla S/M/L de ESA card
    var sizeBtn = e.target.closest('[data-bbx-cart-size-btn]');
    if (sizeBtn) {
      var keyS      = sizeBtn.getAttribute('data-bbx-cart-key');
      var lineS     = sizeBtn.getAttribute('data-bbx-cart-line');
      var variantId = sizeBtn.getAttribute('data-bbx-cart-variant-id');
      if (!keyS || !variantId) return;

      var containerSelector =
        '[data-bbx-cart-sizes][data-bbx-cart-line="' + lineS + '"][data-bbx-cart-key="' + keyS + '"]';
      var container = modal.querySelector(containerSelector);
      if (container) {
        var btns = container.querySelectorAll('.bbx-cart-size-btn');
        for (var i2 = 0; i2 < btns.length; i2++) {
          btns[i2].classList.remove('is-active');
        }
      }
      sizeBtn.classList.add('is-active');

      var addBtn2Selector =
        '[data-bbx-cart-addone][data-bbx-cart-line="' + lineS + '"][data-bbx-cart-key="' + keyS + '"]';
      var addBtn2 = modal.querySelector(addBtn2Selector);
      if (addBtn2) {
        addBtn2.setAttribute('data-bbx-cart-variant-id', variantId);
      }

      changeVariantByKey(keyS, variantId);
      return;
    }
    setInterval(function(){
  if (BBX_CART_COUNT == null) return;
  document.querySelectorAll('[data-bbx-cart-count], [data-cart-count], .cart-count, .header__cart-count')
    .forEach(function(el){
      if (el.textContent !== String(BBX_CART_COUNT)) el.textContent = String(BBX_CART_COUNT);
    });
}, 400);

  });
})();

(function () {
  const totalEl = document.querySelector('[data-bbx-cart-total]');
  const instEl = document.querySelector('[data-bbx-cart-installments-amount]');
  if (!totalEl || !instEl) return;

  const parseMoney = (str) => {
    // Soporta "$1,249.00" / "1,249.00" / "$1249"
    const clean = (str || '').replace(/[^\d.,]/g, '');
    // Si viene "1,249.00" -> quitar comas
    const normalized = clean.replace(/,/g, '');
    const val = parseFloat(normalized);
    return Number.isFinite(val) ? val : 0;
  };

  const formatMXN = (n) => {
    try {
      return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    } catch (e) {
      return '$' + (Math.round(n * 100) / 100).toFixed(2);
    }
  };

  const refresh = () => {
    const total = parseMoney(totalEl.textContent);
    const third = total / 3;
    instEl.textContent = formatMXN(third);
  };

  // 1) al cargar
  refresh();

  // 2) cuando cambie el total (tu JS lo actualiza)
  const obs = new MutationObserver(refresh);
  obs.observe(totalEl, { childList: true, subtree: true, characterData: true });
})();

function updateShippingSavings(cart) {

  const savingsEl = document.querySelector('[data-bbx-cart-shipping-savings]');
  if (!savingsEl) return;

  let itemCount = 0;

  cart.items.forEach(item => {
    itemCount += item.quantity;
  });

  const savings = itemCount * 150;

  if (itemCount > 0) {
    savingsEl.textContent = `Ahorraste $${savings} en envío`;
  } else {
    savingsEl.textContent = '';
  }
}
function formatMoneyMXN(cents) {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format((cents || 0) / 100);
}

function updateShippingSavings(cart) {
  const shippingSavingsEl = document.querySelector('[data-bbx-cart-shipping-savings]');
  if (!shippingSavingsEl) return;

  const FREE_SHIPPING_THRESHOLD = 200000; // $2000 MXN en centavos
  const cartTotal = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
  const missing = FREE_SHIPPING_THRESHOLD - cartTotal;

  if (cartTotal <= 0) {
    shippingSavingsEl.textContent = 'Te faltan $2000 para envío GRATIS';
    return;
  }

  if (missing > 0) {
    shippingSavingsEl.textContent = `Te faltan ${formatMoneyMXN(missing)} para envío GRATIS`;
  } else {
    shippingSavingsEl.textContent = 'Ya tienes envío GRATIS';
  }
}

function bbxEnsureWAPromo(cart) {

  const modal = document.getElementById('bbx-cart-modal');
  if (!modal) return;

  const anchor =
    modal.querySelector('[data-bbx-cart-shipping-savings]') ||
    modal.querySelector('[data-bbx-cart-installments-amount]') ||
    modal.querySelector('[data-bbx-cart-total]');

  if (!anchor) return;

  const container = anchor.parentElement;

  let promo = modal.querySelector('.bbx-wa-promo');

  if (!cart || !cart.items || !cart.items.length) {
    if (promo) promo.remove();
    return;
  }

  if (!promo) {

    promo = document.createElement('div');
    promo.className = 'bbx-wa-promo';

    promo.innerHTML = `
  <div class="bbx-wa-promo-inner">
      <div class="bbx-wa-dot"></div>
      <span>10% OFF</span>
      <span class="bbx-wa-code">WELCOMECHAOS!</span>
  </div>
`;
  

    container.insertBefore(promo, container.firstChild);
  }

  if (!document.getElementById('bbx-wa-style')) {

    const style = document.createElement('style');
    style.id = 'bbx-wa-style';

    style.innerHTML = `

   .bbx-wa-promo{
  display:flex;
  align-items:center;
  justify-content:center;



  width:100%;
  margin:6px 0 12px 0;

  font-size:11px;
  letter-spacing:.06em;
  font-weight:600;

  color:#fff;
}

@media (max-width: 768px){

  .bbx-wa-promo{
    justify-content:flex-start;
    margin:4px 0 8px 0;
  }

  .bbx-wa-promo-inner{
    padding:5px 10px;
    font-size:10px;
  }

}

.bbx-wa-promo-inner{
  display:inline-flex;
  align-items:center;
  gap:8px;

  background:#000;
  padding:6px 12px;

  border-radius:999px;

  box-shadow:0 4px 14px rgba(0,0,0,.15);
}

.bbx-wa-dot{
  width:7px;
  height:7px;
  border-radius:50%;
  background:#25D366;
}

.bbx-wa-code{
  background:#fff;
  color:#000;

  padding:2px 8px;
  border-radius:999px;

  font-weight:700;
}

.bbx-wa-icon{
  width:8px;
  height:8px;
  border-radius:50%;
  background:#25D366;
  flex-shrink:0;
}

.bbx-wa-text strong{
  font-weight:700;
  color:#fff;
}

.bbx-wa-code{
  margin-left:4px;
  padding:2px 6px;

  border-radius:6px;

  background:#111;
  border:1px solid rgba(255,255,255,.2);

  font-weight:700;
  color:#fff;
}

    .bbx-wa-icon{
      font-size:16px;
    }

    .bbx-wa-text strong{
      font-weight:700;
      margin-right:6px;
      color:#000;
    }

    .bbx-wa-code{
      background:#fff;
      padding:3px 8px;
      border-radius:999px;
      font-weight:800;
      letter-spacing:.03em;
      color:#000;
      border:1px solid rgba(0,0,0,.1);
    }

    /* Mobile: mensaje de envío gratis bien acomodado */
@media (max-width: 768px) {
  .bbx-cart-minirow {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .bbx-cart-shipping-savings {
    width: 100%;
    text-align: center;
    white-space: normal;
    line-height: 1.25;
    margin: 0;
  }

  .bbx-cart-summary-text {
    margin: 0;
  }
}
  /* TOTAL + CUPON INLINE */
.bbx-cart-total-row--split {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

/* LEFT */
.bbx-total-left {
  display: flex;
  flex-direction: column;
}

.bbx-cart-total-label {
  font-size: 11px;
  opacity: 0.6;
  letter-spacing: 1px;
}

.bbx-cart-total-amount {
  font-size: 22px;
  font-weight: 700;
}

/* RIGHT (CUPON) */
.bbx-total-right {
  display: flex;
  align-items: center;
}

.bbx-cart-coupon-inline {
  font-size: 12px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 999px;
  background: #000;
  color: #fff;
  white-space: nowrap;
}

/* MOBILE AJUSTE */
@media (max-width: 768px) {
  .bbx-cart-total-amount {
    font-size: 20px;
  }

  .bbx-cart-coupon-inline {
    font-size: 11px;
    padding: 5px 9px;
  }
}

/* REDUCIR ALTURA TOTAL DEL FOOTER */
.bbx-cart-footer {
  padding: 6px 10px !important;
}

/* MENOS ESPACIO ENTRE ELEMENTOS */
.bbx-cart-footer-inner--compact {
  gap: 4px !important;
}

/* TEXTO MÁS COMPACTO */
.bbx-cart-summary-text,
.bbx-cart-shipping-savings,
.bbx-cart-benefits,
.bbx-cart-installments {
  font-size: 11px !important;
  line-height: 1.1 !important;
  margin: 0 !important;
}

/* TOTAL MÁS COMPACTO */
.bbx-cart-total-amount {
  font-size: 17px !important;
  line-height: 1 !important;
}

/* BOTÓN MÁS BAJO (CLAVE) */
.bbx-cart-checkout {
  height: 42px !important;
  min-height: 42px !important;
  font-size: 13px !important;
  margin-top: 2px !important;
}

/* ICONOS MÁS CHICOS */
.bbx-pay-logo,
.bbx-pay-ico {
  height: 13px !important;
}

/* QUITA ESPACIO EXTRA */
.bbx-cart-payments {
  margin-top: 2px !important;
}

/* MINIROW MÁS APRETADO */
.bbx-cart-minirow {
  gap: 2px !important;
}

    `;

    document.head.appendChild(style);
  }
}
window.addEventListener('bbx:cart:urgency:tick', function(e){
  var cart = e && e.detail ? e.detail.cart : null;
  if(!cart || !cart.items) return;

  var count = cart.item_count || 0;

  // Ejemplo: reglas de pulso (tú ajustas)
  if(count >= 3){
    window.dispatchEvent(new CustomEvent('bbx:cart:urgency:pulse', {
      detail: { text: 'Se está moviendo ahora — no lo dejes para después.' }
    }));
  } else if(count >= 1){
    // 40% de las veces
    if(Math.random() < 0.4){
      window.dispatchEvent(new CustomEvent('bbx:cart:urgency:pulse', {
        detail: { text: 'Últimas piezas en rotación. Cierra el look.' }
      }));
    }
  }
});